import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

const EASE = [0.22, 1, 0.36, 1];

const ITEMS = [
  { src: IMAGES.volume, alt: "Extension volume realizzate da Lash Queen", caption: "Extension Volume", cls: "lg:col-span-5", ratio: "3/4" },
  { src: IMAGES.laminazione, alt: "Laminazione sopracciglia prima e dopo", caption: "Laminazione Sopracciglia", cls: "lg:col-span-7 lg:mt-24", ratio: "4/3" },
  { src: IMAGES.massage, alt: "Massaggio viso rilassante", caption: "Rituali di relax", cls: "lg:col-span-7", ratio: "4/3" },
  { src: IMAGES.hero, alt: "Extension one to one effetto naturale", caption: "One to One", cls: "lg:col-span-5 lg:mt-24", ratio: "3/4" },
  { src: IMAGES.megaVolume, alt: "Extension mega volume", caption: "Mega Volume", cls: "lg:col-span-8 lg:col-start-3", ratio: "2/1" },
];

export default function Gallery() {
  return (
    <section id="galleria" data-testid="gallery-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.4em] text-blush-500"
      >
        <span className="h-px w-10 bg-blush-500" />
        Galleria
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="max-w-2xl font-serif text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl"
      >
        I nostri <span className="italic text-blush-500">lavori</span> parlano da soli.
      </motion.h2>

      <div className="mt-20 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        {ITEMS.map((item, i) => (
          <motion.figure
            key={item.caption}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.05 * i }}
            className={`group ${item.cls}`}
          >
            <div className="overflow-hidden rounded-2xl border border-blush-100" style={{ aspectRatio: item.ratio }}>
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
            <figcaption className="mt-4 flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.35em] text-ink-soft">
              <span className="h-px w-6 bg-blush-500" />
              {item.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
